export interface IListTreatmentCategoriesEndpointResponse {
  list: {
    id: string;
    sku: number;
    title: string;
  }[];
}

export const listTreatmentCategoriesEndpoint = () => '/treatments/categories';
